export enum GoalOverviewRoadmapViewOptions {
  List = 'list',
  Timeline = 'timeline',
}
